import {
  Accordion,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  CssBaseline,
  FormControlLabel,
  Paper,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ListAltIcon from "@material-ui/icons/ListAlt";
import RefreshIcon from "@material-ui/icons/Refresh";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Form, Formik } from "formik";
import parse from "html-react-parser";
import MaterialTable from "material-table";
import { DropzoneArea } from "material-ui-dropzone";
import moment from "moment";
// @ts-ignore
import MUIEditor, { MUIEditorState } from "react-mui-draft-wysiwyg";
import LabelsContext from "../../../lang/LabelsContext";
import {
  dateView,
  getDesignationType,
  getTypeFromNameFile,
  handleFileType,
  muiControls,
  richTextStateFromHTML,
} from "../../../utils/Utils";
import EnumDesignation from "../../../utils/enum/EnumDesignation";
import EnumGroup from "../../../utils/enum/EnumGroup";
import HtmlTooltip from "../../system/html-tooltip/HtmlTooltip";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import ArticleCard from "../article-card/ArticleCard";
import { manuscriptFigures } from "../manuscript/submit/TooltipText";
import CheckManuscriptService, { CheckManuscriptServiceType } from "./CheckManuscriptService";
import useStyles from "./CheckManuscriptStyle";
import { FILTER_LAST, useEditorFiles } from "./useEditorFiles";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const SIZE_1MB = 1048576;

export default function CheckManuscript() {
  const { Labels } = LabelsContext();
  const {
    article,
    tabSelected,
    handleChangeTab,
    openNoteDialog,
    openNoteDialogAction,
    closeNoteDialogAction,
    note,
    setNote,
    saveNote,
    correction,
    setCorrection,
    correctionSubjectList,
    saveCorrection,
    openFileDialog,
    openFileDialogAction,
    closeFileDialogAction,
    designationOptions,
    uploadFile,
    filesList,
    handleResetDialog,
    files,
    accept,
    reject,
    uploading,
    validationPaperFiles,
    setValidationPaperFiles,
    filesByAssistant,
    authData,
    openRejectMail,
    openDialog,
    mailSuggestion,
    handleCloseDialog,
    deleteFile,
    revisionSelectedOptionAssistent,
    setRevisionSelectedOptionAssistent,
    updateAssitentFiles,
    selectedDesignation,
    openDialogRegenratePdf,
  }: CheckManuscriptServiceType = CheckManuscriptService();
  const classes = useStyles();
  const theme = useTheme();
  const isAssistant = authData?.user?.group.group === EnumGroup.ASSISTANT;

  const {
    filesFilter,
    revisionOption,
    revisionSelectedOption,
    setRevisionSelectedOption,
    filesToogle,
    setFilesToogle,
  } = useEditorFiles({
    files: filesList,
    visible: !isAssistant,
  });

  return (
    <>
      <CssBaseline />
      <Typography variant="h5">{Labels.CHECK_MANUSCRIPT}</Typography>
      <ArticleCard data={article} index={0} />

      <AppBar position="static" color="default" className={classes.appBar}>
        <Tabs
          value={tabSelected}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={Labels.PAPER_FILES} {...a11yProps(0)} />
          <Tab label={Labels.NOTE} {...a11yProps(1)} />
          <Tab label={Labels.CORRECTION} {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={tabSelected} index={0} dir={theme.direction}>
        <Typography variant="h6">To do:</Typography>
        <Grid container direction="column">
          {validationPaperFiles?.map((validationPaperFile: any) => (
            <FormControlLabel
              key={validationPaperFile.id}
              control={
                <Checkbox
                  checked={validationPaperFile.checked}
                  name={validationPaperFile.name}
                  onClick={() =>
                    setValidationPaperFiles([
                      {
                        ...validationPaperFiles[0],
                        checked: !validationPaperFiles[0].checked,
                      },
                    ])
                  }
                  color="primary"
                />
              }
              label={validationPaperFile.name}
            />
          ))}
        </Grid>

        {isAssistant &&
          filesByAssistant &&
          Object.keys(filesByAssistant)
            .reverse()
            .map((id: any, index: number) => (
              <Accordion defaultExpanded={index === 0}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography className={classes.heading}>Revision #{id}</Typography>
                </AccordionSummary>
                <MaterialTable
                  icons={tableIcons}
                  columns={[
                    { title: Labels.FILE_NAME, field: "id", hidden: true },
                    {
                      title: Labels.FILE_NAME,
                      field: "name",
                      render: (rowData: any) => (
                        <Link href={rowData.location} color="inherit" component="a" target="_blank">
                          {rowData.name}
                          {rowData.type === EnumDesignation.OVERVIEW && <ListAltIcon color="action" />}
                        </Link>
                      ),
                    },
                    {
                      title: Labels.FILE_DESIGNATION,
                      field: "designation",
                      render: (rowData: any) => <div>{getDesignationType(rowData.designation, Labels)}</div>,
                    },
                    {
                      title: Labels.FILE_TYPE,
                      field: "type",
                    },
                    {
                      field: "uploadDate",
                      title: "Upload date",
                      render: (rowData: any) => <div>{moment(rowData.uploadDate).format("YYYY-MM-DD HH:mm")}</div>,
                    },
                  ]}
                  data={updateAssitentFiles(filesByAssistant[id], revisionSelectedOptionAssistent[index]) ?? []}
                  options={{
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    search: false,
                    actionsCellStyle: {
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: 16,
                      width: "100%",
                    },
                  }}
                  editable={{
                    onRowDelete: (newData) => new Promise((resolve, reject) => resolve(deleteFile(newData.id))),
                  }}
                  actions={[
                    ({ new: newFile }) => ({
                      icon: () => <FiberNewIcon style={{ color: "green" }} />,
                      hidden: !newFile,
                      position: "row",
                      onClick: () => {},
                    }),
                    ({ id: fileId, designation }) => ({
                      icon: () => <RefreshIcon />,
                      tooltip: `replace`,
                      hidden: Number(article?.revision) !== Number(id) || designation === EnumDesignation.FULL_ARTICLE,
                      position: "row",
                      onClick: () => openFileDialogAction(fileId),
                    }),
                  ]}
                  title={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" flexDirection="row" alignSelf="center">
                        <Typography>{Labels.MANUSCRIPT_FIGURES}</Typography>
                        <HtmlTooltip title={manuscriptFigures}>
                          <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                        </HtmlTooltip>
                      </Box>
                      <Box flex flexDirection="row" className={classes.box}>
                        <ToggleButtonGroup
                          value={revisionSelectedOptionAssistent[index]}
                          onChange={(item, value: string) => {
                            setRevisionSelectedOptionAssistent({
                              ...revisionSelectedOptionAssistent,
                              [index]: value,
                            });
                          }}
                          exclusive
                          aria-label="text alignment"
                        >
                          <ToggleButton value="all" aria-label="left aligned">
                            All
                          </ToggleButton>
                          <ToggleButton value="last" aria-label="centered">
                            Last
                          </ToggleButton>
                        </ToggleButtonGroup>
                        {index === 0 && (
                          <>
                            <Button
                              style={{
                                textTransform: "none",
                                fontSize: "18px",
                                marginInline: "10px",
                              }}
                              onClick={openFileDialogAction}
                              color="primary"
                              variant="contained"
                            >
                              Add file
                            </Button>
                            <Button
                              style={{
                                textTransform: "none",
                                fontSize: "18px",
                              }}
                              onClick={openDialogRegenratePdf}
                              color="primary"
                              variant="contained"
                            >
                              Regenerate full article pdf
                            </Button>
                          </>
                        )}
                      </Box>
                    </Box>
                  }
                />
              </Accordion>
            ))}
        {!isAssistant && (
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: Labels.FILE_NAME, field: "id", hidden: true },
              {
                title: Labels.FILE_NAME,
                field: "name",
                render: (rowData: any) => (
                  <Link href={rowData.location} color="inherit" component="a" target="_blank">
                    {rowData.name}
                    {rowData.type === EnumDesignation.OVERVIEW && <ListAltIcon color="action" />}
                  </Link>
                ),
              },
              {
                title: Labels.FILE_DESIGNATION,
                field: "designation",
                render: (rowData: any) => <div>{getDesignationType(rowData.designation, Labels)}</div>,
              },
              { title: Labels.FILE_TYPE, field: "type" },
              {
                field: "uploadDate",
                title: "Upload date",
                render: (rowData: any) => <div>{moment(rowData.uploadDate).format("YYYY-MM-DD HH:mm")}</div>,
              },
            ]}
            data={filesFilter}
            options={{
              actionsColumnIndex: -1,
              pageSize: 10,
              search: false,
            }}
            editable={{
              onRowDelete: (newData) =>
                new Promise((resolve, reject) => {
                  resolve(deleteFile(newData.id));
                }),
            }}
            title={
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" flexDirection="row" alignSelf="center">
                  <Typography>{Labels.MANUSCRIPT_FIGURES}</Typography>
                  <HtmlTooltip title={manuscriptFigures}>
                    <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                  </HtmlTooltip>
                </Box>
                <Box flex flexDirection="row" className={classes.box}>
                  <Autocomplete
                    className={classes.revision}
                    value={revisionSelectedOption}
                    onChange={(event, newValue) => {
                      if (newValue?.id === -1) {
                        setFilesToogle(FILTER_LAST);
                      }
                      setRevisionSelectedOption(newValue);
                    }}
                    options={revisionOption}
                    getOptionLabel={(option: any) => option.name}
                    filterSelectedOptions
                    renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.REVISION} />}
                  />
                  <ToggleButtonGroup
                    value={filesToogle}
                    onChange={(item, value: string) => setFilesToogle(value)}
                    exclusive
                    aria-label="text alignment"
                  >
                    <ToggleButton value="all" aria-label="left aligned" disabled={revisionSelectedOption?.id === -1}>
                      All
                    </ToggleButton>
                    <ToggleButton value="last" aria-label="centered">
                      Last
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Button
                    style={{
                      textTransform: "none",
                      fontSize: "18px",
                      marginInline: "10px",
                    }}
                    onClick={() => {
                      openFileDialogAction();
                    }}
                    color="primary"
                    variant="contained"
                  >
                    Add file
                  </Button>
                  <Button
                    style={{
                      textTransform: "none",
                      fontSize: "18px",
                    }}
                    onClick={openDialogRegenratePdf}
                    color="primary"
                    variant="contained"
                  >
                    Regenerate full article pdf
                  </Button>
                </Box>
              </Box>
            }
          />
        )}
        <Formik
          enableReinitialize
          initialValues={{
            designation: selectedDesignation
              ? designationOptions?.find((d: any) => d.code === selectedDesignation.designation)
              : designationOptions[0],
            size: "",
            type: "",
            comments: "",
          }}
          onSubmit={() => {}}
        >
          {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Form>
              <Dialog open={openFileDialog} onClose={closeFileDialogAction} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{Labels.FILE_UPLOAD}</DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={designationOptions}
                        getOptionLabel={(option: any) => option.name}
                        value={values.designation}
                        disabled={!!selectedDesignation}
                        onChange={(event, value) => setFieldValue("designation", value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            id="designation"
                            name="designation"
                            onBlur={handleBlur}
                            label={Labels.FILE_DESIGNATION}
                            error={touched.designation && Boolean(errors.designation)}
                            helperText={touched.designation && errors.designation}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                    <DropzoneArea
                      dropzoneProps={{ disabled: !values.designation }}
                      acceptedFiles={handleFileType(values.designation?.code)}
                      maxFileSize={SIZE_1MB * 50} //50MB
                      onChange={(files: File[]) => {
                        if (files.length > 0) {
                          handleResetDialog(
                            true,
                            setFieldValue,
                            files,
                            (files[0].size / SIZE_1MB).toFixed(2) + " mb",
                            getTypeFromNameFile(files[0].name)
                          );
                        }
                      }}
                      onDelete={(file: File) => {
                        handleResetDialog(false, setFieldValue, null, "", "");
                      }}
                      filesLimit={1}
                    />
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="size"
                        name="size"
                        onBlur={handleBlur}
                        label={Labels.SIZE}
                        value={values.size}
                        error={touched.size && Boolean(errors.size)}
                        helperText={touched.size && errors.size}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="type"
                        name="type"
                        label={`${Labels.FILE_TYPE}:`}
                        value={values.type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.type && Boolean(errors.type)}
                        helperText={touched.type && errors.type}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="comments"
                        name="comments"
                        onBlur={handleBlur}
                        label={Labels.COMMENTS}
                        error={touched.comments && Boolean(errors.comments)}
                        helperText={touched.comments && errors.comments}
                        fullWidth
                        multiline
                        rows={5}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      closeFileDialogAction();
                      handleResetDialog(false, setFieldValue, [], "", "");
                    }}
                    color="primary"
                  >
                    {Labels.CANCEL}
                  </Button>
                  <Button
                    disabled={uploading}
                    onClick={() => {
                      uploadFile(files, values);
                      handleResetDialog(false, setFieldValue, null, "", "");
                    }}
                    color="primary"
                    variant={"contained"}
                  >
                    {Labels.UPLOAD}
                  </Button>
                </DialogActions>
              </Dialog>
            </Form>
          )}
        </Formik>
      </TabPanel>

      <TabPanel value={tabSelected} index={1} dir={theme.direction}>
        <MaterialTable
          icons={tableIcons}
          columns={[
            { field: "date", title: Labels.DATE, render: (rowData) => <div>{dateView(rowData.date)}</div> },
            {
              field: "assistantEditor.firstName",
              title: Labels.AUTHOR,
              render: (rowData: any) => (
                <div>
                  {rowData.assistantEditor.firstName} {rowData.assistantEditor.lastName}
                </div>
              ),
            },
            {
              field: "note",
              sorting: false,
              title: Labels.NOTE,
              render: (rowData) => <div>{parse(rowData.note ? rowData.note : "")}</div>,
            },
          ]}
          title={""}
          data={article.articleNotes}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
          }}
          actions={[
            {
              icon: () => (
                <Typography variant="h6" color="primary">
                  Add note
                </Typography>
              ),
              onClick: (event, rowData: any) => openNoteDialogAction(),
              tooltip: Labels.ADD,
              position: "toolbar",
            },
          ]}
        />
      </TabPanel>
      <TabPanel value={tabSelected} index={2} dir={theme.direction}>
        <Paper className={classes.paper}>
          <Typography variant="h5">{"Problem specification"}</Typography>
          <Grid item xs={6}>
            <Autocomplete
              id="combo-box-demo"
              options={correctionSubjectList}
              getOptionLabel={(option) => option.name}
              value={correction.subject}
              onChange={(event, value) =>
                setCorrection({
                  ...correction,
                  subject: value,
                })
              }
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="normal"
                  id="type"
                  name="type"
                  label={Labels.MANUSCRIPTS}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <MUIEditor
              config={{
                toolbar: { controls: muiControls },
                draftEditor: {
                  stripPastedStyles: true,
                },
              }}
              editorState={correction.details}
              onChange={(state: any) => {
                setCorrection({
                  ...correction,
                  details: state,
                });
              }}
            />
          </Grid>
          <div className={classes.buttonSubmit}>
            <Button onClick={saveCorrection} color="primary" variant="contained">
              {Labels.SUBMIT}
            </Button>
          </div>
        </Paper>
      </TabPanel>
      <div className={classes.buttons}>
        <Button onClick={openRejectMail} color="primary" variant="outlined" className={classes.button}>
          {Labels.REJECT}
        </Button>
        <Button
          onClick={accept}
          color="primary"
          variant="contained"
          className={classes.button}
          disabled={!validationPaperFiles[0].checked}
        >
          {Labels.ACCEPT}
        </Button>
      </div>
      <Dialog maxWidth={"md"} open={openNoteDialog} onClose={closeNoteDialogAction} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{Labels.NOTE}</DialogTitle>
        <DialogContent>
          <MUIEditor
            config={{
              toolbar: { controls: muiControls },
              draftEditor: {
                stripPastedStyles: true,
              },
            }}
            editorState={note}
            onChange={(state: any) => {
              setNote(state);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeNoteDialogAction} color="primary">
            {Labels.CANCEL}
          </Button>
          <Button onClick={saveNote} color="primary" variant="contained">
            {Labels.SAVE}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{Labels.NEW_EMAIL}</DialogTitle>
        {mailSuggestion && (
          <Formik
            initialValues={{
              mailto: mailSuggestion.to ? mailSuggestion.to : [],
              cc: mailSuggestion.cc ? mailSuggestion.cc : [],
              subject: mailSuggestion.subject ? mailSuggestion.subject : "",
              message: mailSuggestion.text ? richTextStateFromHTML(mailSuggestion.text) : MUIEditorState.createEmpty(),
            }}
            onSubmit={(values) => reject(values)}
          >
            {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
              <Form>
                <DialogContent>
                  <Grid container direction="column">
                    <Grid item>
                      <Autocomplete
                        multiple
                        id="tags-mailto"
                        value={values.mailto}
                        onChange={(event, value) => setFieldValue("mailto", value)}
                        options={[{ title: "exampleTest@gmail.com" }].map((option) => option.title)}
                        freeSolo
                        renderTags={(value: string[], getTagProps) =>
                          value.map((option: string, index: number) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                          ))
                        }
                        renderInput={(params) => <TextField {...params} label={Labels.MAILTO} variant="outlined" />}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="subject"
                        name="subject"
                        label={Labels.SUBJECT}
                        value={values.subject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.subject && Boolean(errors.subject)}
                        helperText={touched.subject && errors.subject}
                        fullWidth
                      />
                    </Grid>
                    <Card className={classes.card}>
                      <MUIEditor
                        editorState={values.message}
                        onChange={(state: any) => {
                          setFieldValue("message", state);
                        }}
                        config={{
                          toolbar: { controls: muiControls },
                          draftEditor: {
                            placeholder: Labels.PLACEHOLDER_WRITE_COMMENT,
                            stripPastedStyles: true,
                          },
                        }}
                      />
                    </Card>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDialog} color="primary">
                    {Labels.CANCEL}
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    {Labels.SEND}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
      </Dialog>
    </>
  );
}
